<template>
    <modal name="absentee-bid" @before-open="amount=0">
        <div class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <transition
                    enter-active-class="ease-out duration-300"
                    enter-from-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-active-class="ease-in duration-200"
                    leave-from-class="opacity-100"
                    leave-to-class="opacity-0">

                    <div @click.prevent="$modal.hide('absentee-bid')" class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
                </transition>

                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                <transition
                    enter-active-class="ease-out duration-300"
                    enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-active-class="ease-in duration-200"
                    leave-from-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">

                    <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                        <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                            <button @click="$modal.hide('absentee-bid')" type="button" class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                                <span class="sr-only">{{ $t('general.close') }}</span>
                                <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div class="sm:flex sm:items-start">
                            <div class="mt-3 text-center sm:mt-0 sm:text-left">
                                <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">{{ $t('modals.send_offer') }}</h3>
                                <div class="mt-2">
                                    <p class="text-sm text-gray-500">{{ $t('modals.send_offer_details') }}</p>
                                </div>
                                <div class="mt-2">
                                    <select v-model="amount" class="w-full inline-flex items-center justify-center bg-gray-100 text-black px-6 py-3 text-base font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black" :placeholder="$t('modals.maximum_amount')">
                                        <option value="" disabled selected>{{ $t('modals.maximum_amount') }}</option>
                                        <option v-for="step in steps" :value="step" :key="step">
                                            <money-format
                                                :value="step"
                                                locale="ro"
                                                currency-code="eur"
                                                :subunits-value="false"
                                                :hide-subunits="true">
                                            </money-format>
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                            <button :disabled="! canAbsenteeBid" @click.prevent="sendAbsenteeBid" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm">
                                {{ $t('modals.send_absentee_bid') }}
                            </button>
                            <button @click.prevent="$modal.hide('absentee-bid')" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:w-auto sm:text-sm">
                                {{ $t('general.cancel') }}
                            </button>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Constants } from '../../constants'
import { Functions } from '../../functions'

export default {
    props: [
        'lot', 'auction'
    ],
    data () {
        return {
            ...Constants,
            amount: ''
        }
    },
    computed: {
        ...mapGetters({
            user: 'getUser',
        }),
        steps () {
            if(! this.lot) return []

            let step = this.lot.k || this.lot.p
            let steps = []
            for(var i=1; i<=10; i++) {
                step = Functions.getNextStep(this.lot.i, step)
                steps.push(step)
            }
            return steps
        },
        canAbsenteeBid () {
            if(! this.lot) return false
            if(! [this.LOT_AUCTION_STATUS_OPEN, this.LOT_AUCTION_STATUS_PENDING].includes(this.lot.s)) return false
            if(! this.user.id) return false
            if(this.lot.k > 0 && this.amount <= this.lot.k) return false
            if(this.amount <= this.lot.p) return false

            return true
        },
        description () {
            let artist = ''
            if(this.lot.a) {
                artist = this.lot.a + ', '
            }
            return artist + this.lot.t
        }
    },
    methods: {
        sendAbsenteeBid () {
            this.$store.dispatch('sendAbsenteeBid', {
                lot_id: this.lot.id,
                auction_id: this.auction.id,
                amount: this.amount
            }).then(() => {
                this.$notify({
                    text: this.$t('lot.absentee_sent'),
                    type: 'success',
                })
            })
            this.$modal.hide('absentee-bid')
        },
        close () {
            this.$modal.hide('absentee-bid')
        }
    },
}
</script>
